
import React, { useState, useEffect } from 'react';
import { postData } from '../../../../Services/Fetchnodeservices';
import { X, Save, Sparkles, Trash2 } from 'lucide-react';
import ImageSearchModal from './ImageSearchModal';

const EditItemModal = ({ isOpen, onClose, item, designationId, onUpdate, ts }) => {
    const [formData, setFormData] = useState(null);
    const [saving, setSaving] = useState(false);
    const [showImageFinder, setShowImageFinder] = useState(false);

    useEffect(() => {
        if (item) {
            const variants = Array.isArray(item.variant) ? item.variant : JSON.parse(item.variant || '[]');
            const processed = variants.map(v => ({
                ...v,
                actual_price: v.actual_price || (parseFloat(v.item_price_variant) / 1.2).toFixed(0)
            }));
            setFormData({ ...item, variant: processed });
        }
    }, [item]);

    const calculateCustomerPrice = (menuP) => Math.round((parseFloat(menuP) || 0) * 1.20);

    const handleSave = async () => {
        setSaving(true);
        try {
            const finalVariants = formData.variant.map(v => ({
                ...v,
                actual_price: parseFloat(v.actual_price) || 0,
                item_price_variant: calculateCustomerPrice(v.actual_price),
                unit: (v.unit_value || "Price").toLowerCase(),
                is_available_variant: "yes"
            }));

            const finalItem = {
                ...formData,
                variant: finalVariants,
                requested_price: finalVariants[0]?.actual_price || 0,
                price: finalVariants[0]?.item_price_variant || 0
            };

            const resp = await postData(`menu/update-menu/${designationId}/${item.product_id}`, finalItem, 'PUT');
            if (resp.success) { onUpdate(); onClose(); }
        } catch (e) { alert(e.message); }
        finally { setSaving(false); }
    };

    if (!isOpen || !formData) return null;

    const styles = {
        overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' },
        modal: { background: ts.surface, width: '95%', maxWidth: '500px', borderRadius: '24px', border: `1px solid ${ts.border}`, color: ts.textPrimary, overflow: 'hidden', backgroundImage: ts.gradientCard },
        input: { width: '100%', padding: '12px', borderRadius: '12px', background: ts.background, border: `1px solid ${ts.border}`, color: ts.textPrimary, marginBottom: '15px', outline: 'none' },
        vRow: { display: 'flex', gap: '10px', alignItems: 'center', background: ts.surfaceLighter, padding: '12px', borderRadius: '15px', marginBottom: '10px', border: `1px solid ${ts.border}` }
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <div style={{ padding: '20px', borderBottom: `1px solid ${ts.border}`, display: 'flex', justifyContent: 'space-between' }}>
                    <h3 style={{ margin: 0 }}>Edit Luxury Item</h3>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', color: ts.textMuted }}><X /></button>
                </div>
                <div style={{ padding: '24px', maxHeight: '70vh', overflowY: 'auto' }}>
                    <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
                        <div style={{ textAlign: 'center' }}>
                            <img src={formData.pic1?.startsWith('http') ? formData.pic1 : `https://zaptodoor.com/uploads/${formData.pic1}`} style={{ width: '100px', height: '100px', borderRadius: '16px', objectFit: 'cover' }} />
                            <button onClick={()=>setShowImageFinder(true)} style={{ marginTop: '8px', background: ts.primary, color: 'black', border: 'none', padding: '5px 10px', borderRadius: '8px', fontSize: '10px', fontWeight: 'bold', cursor: 'pointer' }}><Sparkles size={10}/> AI Search</button>
                        </div>
                        <div style={{ flex: 1 }}>
                            <input style={styles.input} value={formData.name} onChange={e=>setFormData({...formData, name:e.target.value})} placeholder="Item Name" />
                            <select style={styles.input} value={formData.is_veg} onChange={e=>setFormData({...formData, is_veg: e.target.value})}>
                                <option value="yes">Veg</option><option value="no">Non-Veg</option>
                            </select>
                        </div>
                    </div>
                    <textarea style={{ ...styles.input, height: '60px' }} value={formData.description} onChange={e=>setFormData({...formData, description:e.target.value})} placeholder="Description" />
                    
                    <div style={{display:'flex', justifyContent:'space-between', marginBottom:'10px'}}><label style={{fontSize:'12px', fontWeight:700}}>PRICING (MENU PRICE)</label><button onClick={()=>setFormData({...formData, variant: [...formData.variant, {unit_value:'', actual_price:0}]})} style={{color:ts.primary, background:'none', border:'none', fontSize:'12px', cursor:'pointer'}}>+ Add Price</button></div>
                    
                    {formData.variant.map((v, i) => (
                        <div key={i} style={styles.vRow}>
                            <input style={{...styles.input, marginBottom:0, flex:1.5}} placeholder="Unit" value={v.unit_value} onChange={e=>{let nv=[...formData.variant]; nv[i].unit_value=e.target.value; setFormData({...formData, variant:nv})}} />
                            <input style={{...styles.input, marginBottom:0, flex:1}} type="number" placeholder="Menu ₹" value={v.actual_price} onChange={e=>{let nv=[...formData.variant]; nv[i].actual_price=e.target.value; setFormData({...formData, variant:nv})}} />
                            <div style={{flex:1, textAlign:'right'}}><div style={{fontSize:'10px', color:ts.textMuted}}>App Price</div><div style={{color:ts.success, fontWeight:700}}>₹{calculateCustomerPrice(v.actual_price)}</div></div>
                            <button onClick={()=>{let nv=formData.variant.filter((_,idx)=>idx!==i); setFormData({...formData, variant:nv})}} style={{ color: ts.error, background: 'none', border: 'none' }}><Trash2 size={16}/></button>
                        </div>
                    ))}
                </div>
                <div style={{ padding: '20px', borderTop: `1px solid ${ts.border}`, display: 'flex', gap: '10px' }}>
                    <button onClick={onClose} style={{ flex: 1, padding: '12px', borderRadius: '12px', border: `1px solid ${ts.border}`, background: 'none', color: ts.textSecondary }}>Cancel</button>
                    <button onClick={handleSave} disabled={saving} style={{ flex: 2, padding: '12px', borderRadius: '12px', background: ts.primary, color: 'black', border: 'none', fontWeight: 700 }}>{saving ? "Updating..." : "Save Luxury Item"}</button>
                </div>
            </div>
            {showImageFinder && <ImageSearchModal isOpen={showImageFinder} onClose={()=>setShowImageFinder(false)} query={formData.name} onSelect={img=>{setFormData({...formData, pic1:img}); setShowImageFinder(false);}} />}
        </div>
    );
};

export default EditItemModal;